<div
  class="time-warning-wrapper"
  *ngIf="
    (installationFeaturesStore.isLocalVsDeviceTimeMismatch() | async) && (offSetDeviceTime$ | async)
  "
>
  <app-banner type="warning">
    {{ '+INSTALLATIONS.INSTALLATION.DATE_AND_TIME.DEVICE_AND_LOCAL_TIME_MISMATCH' | translate }}
  </app-banner>

  <app-edit-device-time [device]="device"></app-edit-device-time>
</div>
